// extracted by mini-css-extract-plugin
export var currencyInput = "_ns-1";
export var currencySymbol = "_ns-0";